module.exports = __webpack_public_path__ + "img/increase.4fab9bda.svg";